
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  GetAllIpBlack,
  UpdateIpBlack,
  DelIpBlack,
  GetAllPlatform,
  RefreshConfig
} from '@/api/admin/risk'
@Component
export default class UserBlack extends Vue {
  select = {
    Platform_List: [],
    app_list: [],
    type_List: [
      { value: 0, name: 'IP黑名单' },
      { value: 1, name: 'Mac地址' }
    ]
  }
  tableMaxHeight = 0
  table = {
    params: {
      platid: 0,
      ctype: -1,
      val: '',
      page: 1,
      page_size: 10
    },
    data: [],
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      {
        key: 'platid',
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let app_info =
            this.select.Platform_List.find(
              item => item['value'] == params.row.platid
            ) || []
          return h('div', [
            h('span', app_info ? app_info['name'] : ''),
            h(
              'span',
              { style: 'color:#bbb;' },
              `（${app_info ? app_info['value'] : ''}）`
            )
          ])
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '所属分组', '显示对应玩家所属分组')
      },
      // {key: "id",align: "center",minWidth: 120,
      //     renderHeader: (h, params) =>
      //         (this as any).renderHeader(h, "编号", "显示此条列表数据对应的编号")
      // },
      {
        key: 'ctype',
        align: 'center',
        minWidth: 120,
        render: (h, params) =>
          h('span', ['IP黑名单', 'Mac地址'][params.row.ctype]),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '限制类型',
            '显示该条信息配置的限制类型'
          )
      },
      {
        key: 'val',
        align: 'center',
        minWidth: 120,
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '限制配置内容',
            '显示该条信息配置的限制内容'
          )
      },
      {
        key: 'status',
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          return h(
            'span',
            { style: { color: params.row.status ? 'green' : 'red' } },
            params.row.status ? '启用' : '禁用'
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '状态', '显示对应玩家的状态')
      },
      {
        key: 'utime',
        align: 'center',
        minWidth: 120,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '修改时间', '显示对应的修改时间')
      },
      {
        key: 'desc',
        align: 'center',
        minWidth: 120,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '备注', '显示对应的备注')
      },

      {
        key: '',
        align: 'center',
        title: '管理',
        minWidth: 220,
        fixed: 'right',
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '5px 20px' },
                on: {
                  click: () => {
                    ;(this.SetModal.form.params as any) = {
                      id: params.row.id,
                      platid: params.row.platid,
                      val: params.row.val,
                      status: params.row.status,
                      ctype: params.row.ctype,
                      desc: params.row.desc
                    }
                    this.SetModal.show = true
                  }
                }
              },
              '编辑配置'
            ),
            h(
              'Button',
              {
                props: { type: 'error' },
                style: { margin: '2px', padding: '5px 20px' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认删除',
                      content: '确认删除此条记录',
                      onOk: () => {
                        this.delIpBlack(params.row.id)
                        // this.onlingPayUser.param['type'] = 2
                        // this.onlingPayUser.param['id'] = params.row.id
                        // this.updateonlingPayUser()
                      }
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ],
    total: 0,
    pageSizes: [10, 20, 30, 40]
  }
  SetModal = {
    show: false,
    form: {
      ref: 'gameriskSet',
      params: {
        id: '',
        platid: 0,
        val: '',
        status: 1,
        ctype: 0,
        desc: ''
      },
      rules: {
        val: [{ required: true, message: '请输入配置内容', trigger: 'blur' }]
      }
    }
  }
  GetPlatform() {
    GetAllPlatform({}).then(res => {
      let data = res._param.data || []
      let nlist: any = [{ value: 0, name: '全平台' }]
      data.map(item => {
        nlist.push({
          value: item.id,
          name: item.name
        })
      })
      this.select.Platform_List = nlist
    })
  }
  setModalShow() {
    this.SetModal.show = true
    this.SetModal.form.params = {
      id: '',
      platid: 0,
      val: '',
      status: 1,
      ctype: 0,
      desc: ''
    }
  }
  closeOpen() {
    ;(this.$refs.gameriskSet as any).resetFields()
    this.SetModal.show = false
  }
  //g更新信息
  updateIpBlack() {
    ;(this.$refs.gameriskSet as any).validate((valid: boolean) => {
      if (valid) {
        let param = { ...this.SetModal.form.params }
        UpdateIpBlack(param).then(res => {
          this.getAllIpBlack()
          this.closeOpen()
        })
      } else {
      }
    })
  }
  //获取列表
  getAllIpBlack(num?) {
    if (num) {
      this.table.params.page = 1
    }
    let param = {
      ...this.table.params,
      ctype: this.table.params.ctype == null ? -1 : this.table.params.ctype
    }
    GetAllIpBlack(param).then(res => {
      this.table.data = res._param.data || []
      this.table.total = res._param.total
    })
  }
  limitchange(limit) {
    this.table.params.page = 1
    this.table.params.page_size = limit
    this.getAllIpBlack()
  }
  pagechange(page) {
    this.table.params.page = page
    this.getAllIpBlack()
  }

  //删除
  delIpBlack(id) {
    DelIpBlack({ id }).then(res => {
      this.getAllIpBlack()
      // this.closeOpen()
    })
  }

  Refres() {
    let param = { is_all: 1, refresh_cfg: [4] }
    RefreshConfig(param).then(res => {
      this.$Notice.success({
        title: '操作提示',
        desc: '成功刷新配置'
      })
      // this.getUserRiskList();
    })
  }
  created() {
    this.getAllIpBlack()
    this.GetPlatform()
  }
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
  }
}
